import { render, staticRenderFns } from "./SelectSearch.vue?vue&type=template&id=6673ffc5&"
import script from "./SelectSearch.vue?vue&type=script&lang=js&"
export * from "./SelectSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports